import { isValidDealerPortal } from 'src/utils/helpers';
import { IUser } from '../../../../utils/interfaces/user';
import LockedAccount from '../../pages/lockedaccount';
import Login from '../../pages/login/index';
import { MaintenanceContext } from 'src/context/MaintenanceContext';
import MfaCode from '../../pages/mfacode';
import { Navigate } from 'react-router-dom';
import QrCode from '../../pages/qrcode';
import { useSelector } from 'react-redux';
import { COGNITO_TOKEN_NAME, PERMISSIONS_TOKEN_NAME } from '../../../../config';
import React, { useContext, useEffect } from 'react';

const LoginPage: React.FC = () => {
    const { maintenanceMode }: any = useContext(MaintenanceContext);
    const userState = useSelector((state: IUser) => {
        return state;
    });
    const { dealerCountry } = userState;
    const validDealerPortal =
        dealerCountry !== null && isValidDealerPortal(dealerCountry);

    function areTokenValid(): boolean {
        const cognitoToken = window.sessionStorage.getItem(COGNITO_TOKEN_NAME);
        const permissionsToken = window.sessionStorage.getItem(
            PERMISSIONS_TOKEN_NAME,
        );
        const resp = cognitoToken && permissionsToken ? true : false;
        return resp;
    }

    useEffect(() => {
        if (areTokenValid() && !validDealerPortal) {
            sessionStorage.clear();
        }
    }, [validDealerPortal]);

    let loginPage: JSX.Element = <Login />;

    if (!maintenanceMode) {
        if (userState.isLocked) {
            loginPage = <LockedAccount />;
        } else if (
            ((userState.isDeviceRemembered || userState.isMfaTokenValid) &&
                userState.isAuth) ||
            areTokenValid()
        ) {
            if (validDealerPortal) {
                loginPage = <Navigate to='/dashboard' />;
            } else {
                loginPage = <Login />;
            }
        } else if (!userState.isMfaRegistered && userState.isAuth) {
            loginPage = <QrCode />;
        } else if (userState.isMfaRegistered && userState.isAuth) {
            loginPage = <MfaCode />;
        }
    }

    return <div>{loginPage}</div>;
};

export default LoginPage;
